module.exports = __webpack_public_path__ + "img/icon-map.209fecb5.svg";